export default {"src":"/_next/static/image/public/images/ic_delivery_scooter.27e24ad053a9b7e0f8b32858419346cd.svg","height":34,"width":40};